export default {
  title: 'Preguntas Frecuentes',
  subtitle: '¿En qué podemos ayudarte?',
  loginAndTechnicalRequirements: 'Ingreso y requerimientos técnicos',
  kimpleUsers: 'Usuarios Kimple',
  profile: 'Perfil',
  content: 'Contenido',
  folders: 'Carpetas',
  sharingContent: 'Compartir contenido',
  rating: 'Valoración',
  metrics: 'Métricas',
  contact: 'Contacto',
  creatingContent: 'Crear contenido'
}

export const en = {
  title: 'Frequently Asked Questions',
  subtitle: 'How can we help you?',
  loginAndTechnicalRequirements: 'Login and technical requirements',
  kimpleUsers: 'Kimple Users',
  profile: 'Profile',
  content: 'Content',
  folders: 'Folders',
  sharingContent: 'Share content',
  rating: 'Rating',
  metrics: 'Metrics',
  contact: 'Contact',
  creatingContent: 'Create content'
}

export const ca = {
  title: 'Preguntes Freqüents',
  subtitle: 'om et podem ajudar?',
  loginAndTechnicalRequirements: 'Accés i requisits tècnics',
  kimpleUsers: 'Usuaris Kimple',
  profile: 'Perfil',
  content: 'Contingut',
  folders: 'Carpetes',
  sharingContent: 'Comparteix contingut',
  rating: 'Valoració',
  metrics: 'Mètriques',
  contact: 'Contacte',
  creatingContent: 'Crea contingut'
}
